import { Link, type RouteObject } from 'react-router-dom';
import { ROUTE_PATHS } from '@/constants/common';

export const tasksRoute: RouteObject = {
  path: ROUTE_PATHS.tasks,
  lazy: async () => ({
    Component: (await import('@/pages/TasksPage')).TasksPage,
  }),
  handle: {
    title: '任务管理',
    crumb: () => <Link to={ROUTE_PATHS.tasks}>任务管理</Link>,
  },
};
